/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityServiceArea } from './FacilityServiceArea';
import {
    FacilityServiceAreaFromJSON,
    FacilityServiceAreaFromJSONTyped,
    FacilityServiceAreaToJSON,
    FacilityServiceAreaToJSONTyped,
} from './FacilityServiceArea';

/**
 * 
 * @export
 * @interface FindAllFacilityServiceAreasResponse
 */
export interface FindAllFacilityServiceAreasResponse {
    /**
     * 
     */
    data: Array<FacilityServiceArea>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllFacilityServiceAreasResponse interface.
 */
export function instanceOfFindAllFacilityServiceAreasResponse(value: object): value is FindAllFacilityServiceAreasResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllFacilityServiceAreasResponseFromJSON(json: any): FindAllFacilityServiceAreasResponse {
    return FindAllFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function FindAllFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityServiceAreasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FacilityServiceAreaFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllFacilityServiceAreasResponseToJSON(json: any): FindAllFacilityServiceAreasResponse {
    return FindAllFacilityServiceAreasResponseToJSONTyped(json, false);
}

export function FindAllFacilityServiceAreasResponseToJSONTyped(value?: FindAllFacilityServiceAreasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(FacilityServiceAreaToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

